// covered-by: frontends/carrie/src/ask-v2/rail/__tests__/mergeRailProgress.test.ts
import { type AskV2RailContent, type AskV2RailProgressItem } from "./types";

export function mergeRailProgress(
  base: AskV2RailContent,
  progress: { items: AskV2RailProgressItem[]; showShell: boolean },
): AskV2RailContent {
  if (!progress.showShell && progress.items.length === 0) {
    return base;
  }

  return {
    ...base,
    progress: {
      status: base.progress?.status,
      items: progress.items,
    },
  };
}
